import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function firstValidationError(payload) {
  const errors = payload?.errors;
  if (!errors || typeof errors !== 'object') return null;
  const first = Object.values(errors)[0];
  if (Array.isArray(first) && first[0]) return String(first[0]);
  if (typeof first === 'string') return first;
  return null;
}

function createKasirInkoJump() {
  return {
    publicUrl: '',
    saving: false,
    loadingClaims: false,
    claimFilter: '',
    claimStatuses: ['pending', 'contacted', 'rewarded', 'rejected'],
    claims: [],
    form: {
      target_score: 100,
      prize_type: '',
      prize_title: '',
      prize_description: '',
      winner_message: '',
      is_active: true,
      claims_enabled: true,
      max_claims_per_phone: 1,
    },

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.applyConfig(cfg);
      } catch (e) {
        console.error('kasirInkoJump config', e);
      }
      this.loadClaims();
    },

    applyConfig(cfg) {
      this.publicUrl = cfg.public_url || '/maintenance';
      this.claimStatuses = cfg.claim_statuses || this.claimStatuses;
      const s = cfg.settings || {};
      this.form.target_score = Number(s.target_score) || 100;
      this.form.prize_type = s.prize_type || '';
      this.form.prize_title = s.prize_title || '';
      this.form.prize_description = s.prize_description || '';
      this.form.winner_message = s.winner_message || '';
      this.form.is_active = s.is_active !== false;
      this.form.claims_enabled = s.claims_enabled !== false;
      this.form.max_claims_per_phone = Number(s.max_claims_per_phone) || 1;
    },

    async saveSettings() {
      if (this.saving) return;
      this.saving = true;
      try {
        // POST (bukan PUT) — lebih aman di Hostinger / proxy yang memblokir PUT
        const { data } = await axios.post('/api/v1/kasir/inko-jump', {
          target_score: Number(this.form.target_score) || 0,
          prize_type: this.form.prize_type,
          prize_title: this.form.prize_title,
          prize_description: this.form.prize_description,
          winner_message: this.form.winner_message,
          is_active: !!this.form.is_active,
          claims_enabled: !!this.form.claims_enabled,
          max_claims_per_phone: Number(this.form.max_claims_per_phone) || 1,
        });
        this.applyConfig(data.data || {});
        window.toast?.(data.message || 'Pengaturan disimpan.', 'success');
      } catch (e) {
        const payload = e?.response?.data;
        const msg =
          firstValidationError(payload) ||
          payload?.message ||
          'Gagal menyimpan. Cek koneksi database (DB_HOST=127.0.0.1) lalu coba lagi.';
        window.toast?.(msg, 'error');
      } finally {
        this.saving = false;
      }
    },

    async loadClaims() {
      this.loadingClaims = true;
      try {
        const params = {};
        if (this.claimFilter) params.status = this.claimFilter;
        const { data } = await axios.get('/api/v1/kasir/inko-jump/claims', { params });
        this.claims = Array.isArray(data.data) ? data.data : [];
      } catch (e) {
        window.toast?.(e?.response?.data?.message || 'Gagal memuat klaim.', 'error');
      } finally {
        this.loadingClaims = false;
      }
    },

    async saveClaim(c) {
      try {
        const { data } = await axios.post(`/api/v1/kasir/inko-jump/claims/${c.id}`, {
          status: c.status,
        });
        Object.assign(c, data.data || {});
        window.toast?.(data.message || 'Status diperbarui.', 'success');
      } catch (e) {
        const payload = e?.response?.data;
        window.toast?.(
          firstValidationError(payload) || payload?.message || 'Gagal update klaim.',
          'error',
        );
      }
    },
  };
}

Alpine.data('kasirInkoJump', createKasirInkoJump);
